import { api, ApiError } from "../core/api.js";
import { h, mount } from "../core/dom.js";
import { navigate } from "../core/router.js";
import { saveSession } from "../core/tokens.js";
import { t } from "../core/i18n.js";
import { start as oauthStart } from "./oauth.js";
import type { Session } from "../models.js";

/**
 * Landing / login. AI 사전 고지(00 §7.1, 한국 AI기본법 31조 1항) + social login.
 * Web OAuth = Authorization Code + PKCE (01 §3.A) — social buttons start that flow.
 * dev-login is shown only against a local API for convenience.
 */
export function loginView(_params: Record<string, string>, root: HTMLElement): void {
  const devHandle = h("input", { class: "field", placeholder: t("login.devHandle") }) as HTMLInputElement;
  const status = h("p", { class: "muted" }, "");

  const devLogin = async (): Promise<void> => {
    const handle = devHandle.value.trim();
    if (!handle) {
      status.textContent = t("login.handleRequired");
      return;
    }
    try {
      const s = await api.post<Session>("/v1/auth/dev-login", { handle });
      saveSession(s);
      navigate("/feed");
    } catch (e) {
      const msg = e instanceof ApiError ? `${e.status} ${e.code}` : String(e);
      status.textContent = t("login.failed", { msg });
      status.className = "error";
    }
  };

  mount(
    root,
    h(
      "section",
      { style: "max-width:420px;margin:0 auto" },
      h("h1", {}, "ShortDrama"),
      h("p", { class: "muted" }, t("login.tagline")),
      h(
        "div",
        { class: "card", style: "padding:14px;margin:16px 0" },
        h("p", { class: "muted", style: "font-size:13px;margin-top:0" }, t("compliance.aiNotice")),
      ),
      h("button", { class: "btn", style: "width:100%", onclick: () => void oauthStart("google") }, t("login.google")),
      h("button", { class: "btn secondary", style: "width:100%;margin-top:8px", onclick: () => void oauthStart("apple") }, t("login.apple")),
      h("hr", { style: "border-color:#2a2a32;margin:20px 0" }),
      h("p", { class: "muted", style: "font-size:12px" }, t("login.devSection")),
      devHandle,
      h("button", { class: "btn", style: "width:100%", onclick: devLogin }, t("login.devButton")),
      status,
    ),
  );
}
